const messages = {
  en: {
    translations: {
      ticketInfo: {
        openCustomFieldsButton: "Contact custom fields",
        customFieldsDrawerTitle: "Contact fields",
        copyPhone: "Copy phone",
        quickMessages: "Quick replies",
        sendPixKey: "Send PIX key",
        sendPixKeySuccess: "PIX key sent in the ticket.",
        phonecopied: "Phone copied to clipboard!",
        noPhone: "No phone available to copy",
        copyError: "Error copying phone",
      },
      signup: {
        title: "Sign Up",
        toasts: {
          success: "User successfully created! Please log in!",
          disabled:
            "User registration is currently disabled. Please try again later.",
          fail: "Error creating user. Please check the provided data.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          company: "Organization Name",
          phone: "WhatsApp (Area Code + Number)",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      conecthubEmbed: {
        title: "Connect ConectHUB 360",
        webhookHelp:
          "Copy the webhook URL below and paste it in the ConectHUB / Meta flow when asked.",
        openEmbed: "Open ConectHUB flow",
        embedRunning:
          "Complete the flow in the ConectHUB window. When finished, the connection will update automatically.",
        close: "Close",
        copied: "URL copied!",
        copyFail: "Could not copy.",
        payloadRecoveryTitle: "Could not save automatically",
        payloadRecoveryHelp:
          "ConectHUB returned the data successfully, but the system could not save it. Copy the JSON below and save it in a text file for support or to retry later.",
        copyPayload: "Copy response JSON",
        payloadCopied: "JSON copied!",
        success: "Official WhatsApp connection updated successfully!",
        errors: {
          masterConfig:
            "The administrator must set the public link and ConectHUB Account ID in Settings → Plans.",
          generic: "Could not start the flow.",
          save: "Could not save Meta data.",
          embed: "ConectHUB flow error.",
          script: "Could not load the ConectHUB script."
        }
      },
      conecthub360Picker: {
        title: "Choose channel",
        subtitle: "Select the channel you want to connect:",
        whatsappOfficial: "Official WhatsApp",
        facebook: "Facebook",
        instagram: "Instagram",
        telegram: "Telegram",
        comingSoon: "COMING SOON",
        planNoWhatsappOfficial:
          "Your plan does not include Official WhatsApp or WhatsApp for this flow.",
        planNoFacebook: "Your plan does not include Facebook.",
        planNoInstagram: "Your plan does not include Instagram.",
        planNoConecthub360:
          "Your plan does not include ConectHUB 360 to connect Telegram here."
      },
      conecthubMeta: {
        titleFacebook: "Facebook (ConectHUB)",
        titleInstagram: "Instagram (ConectHUB)",
        titleTelegram: "Telegram (ConectHUB)",
        hubChannelNoticeTitle: "Official embed.js integration",
        hubChannelNoticeBody:
          "Conect HUB 360 opens the popup at /connect/{channel}/{accountId} (e.g. /connect/facebook/…), matching the official embed.js. Use the webhook and callback below when the hub asks for them.",
        webhookHelp:
          "Use the URLs below in the ConectHUB flow when asked. The webhook is the same Meta endpoint your app already uses for native Facebook and Instagram (POST /webhook).",
        webhookLabel: "Webhook (backend URL)",
        callbackLabel: "Callback URL",
        telegramHelp:
          "Use the same ConectHUB 360 Account ID and public link configured on the master company (as in the hub panel under Direct Link → Telegram). No new .env variables are required just to connect—the official hub embed flow is used.",
        telegramDirectLinkLabel: "Direct Telegram link (ConectHUB panel — Direct Link)",
        telegramDirectLinkWithWebhookLabel:
          "Direct link with webhook (recommended — ConectHUB docs «Direct links per channel»)",
        telegramDirectLinkWithWebhookHint:
          "Includes ?embed=true&webhook_url=… so the hub knows where to POST inbound messages when connecting in the browser. Use channel segment telegram: …/connect/telegram/{accountId}.",
        telegramInboundWebhookLabel: "Telegram inbound webhook (received messages)",
        telegramInboundWebhookHelp:
          "Set this URL in ConectHUB so the hub can POST received messages to your system. It is not the Meta webhook (Facebook/Instagram): use POST …/webhook/telegram-mtproto. The URL must be reachable on the internet (public BACKEND_URL); localhost cannot receive hub callbacks — use a tunnel (ngrok, Cloudflare Tunnel) or a deployed server.",
        telegramWebhookOptional:
          "Set BACKEND_URL to your public backend URL to generate the Telegram inbound webhook. Without it, the hub cannot deliver messages to your system.",
        successFacebook: "Facebook connected successfully!",
        successInstagram: "Instagram connected successfully!",
        successTelegram: "Telegram connected successfully!",
        errors: {
          masterAccount:
            "Set the ConectHUB Account ID on the master company (Settings → Plans).",
          backendUrl:
            "Set BACKEND_URL on the server (public backend URL) to build webhook and callback URLs.",
          generic: "Could not start the flow.",
          save: "Could not save the connection. Check the data returned by ConectHUB.",
          tokenShape:
            "ConectHUB response missing a recognized user token. Copy the JSON for support or check field names (access_token, user id).",
          popupBlocked: "Allow pop-ups for this site to open ConectHUB."
        }
      },
      telegramBot: {
        title: "Connect Telegram Bot",
        instructions: "To connect Telegram, you need a Bot Token.",
        instructionsDetail:
          "1. Open Telegram and search for @BotFather\n2. Send /newbot and follow the instructions\n3. Copy the generated token and paste it below",
        nameLabel: "Connection name (optional)",
        namePlaceholder: "E.g. Telegram Support",
        tokenLabel: "Bot Token",
        tokenHelp: "Format: 123456789:ABCDefGhIJKlmnOPQrstUVwxyz...",
        tokenRequired: "Enter the bot token.",
        invalidToken: "Invalid token format. Use the token provided by @BotFather.",
        btnConnect: "Validate and Connect",
        validating: "Validating token and configuring webhook...",
        success: "Telegram connected successfully!",
        successTitle: "Bot connected!",
        done: "Done",
        cancel: "Cancel",
        menuLabel: "Telegram Bot (@BotFather)",
        errors: {
          connectFail: "Failed to connect the Telegram bot."
        }
      },
      telegramPersonal: {
        title: "Telegram — personal account",
        menuLabel: "Telegram personal (MTProto)",
        help:
          "Connect your real Telegram account (not a bot). Messages received on this account will appear in MultiFlow.",
        phoneLabel: "Phone number",
        phoneHint: "International format with country code, e.g. +5518998020650",
        phoneRequired: "Enter the phone number.",
        nameLabel: "Connection name (optional)",
        sendCode: "Send code",
        codeSent: "Code sent! Check Telegram.",
        codeLabel: "Verification code",
        codeRequired: "Enter the code you received.",
        codeHelp: "Enter the code sent to {{phone}} in the Telegram app.",
        verifyCode: "Confirm code",
        need2fa: "This account uses two-step verification (2FA).",
        passwordLabel: "2FA password",
        passwordRequired: "Enter your two-step verification password.",
        passwordHelp: "Enter your Telegram two-step verification password.",
        verifyPassword: "Confirm password",
        success: "Personal Telegram connected!",
        cancel: "Cancel",
        close: "Close",
        serverNotConfigured:
          "Server missing TELEGRAM_API_ID / TELEGRAM_API_HASH. Set them in backend .env (my.telegram.org/apps).",
        errors: {
          sendCode: "Failed to send code.",
          verifyCode: "Invalid or expired code.",
          verifyPassword: "Invalid 2FA password."
        }
      },
      login: {
        title: "Login",
        welcome: "Welcome back",
        loginInstruction: "Enter your credentials to access your account",
        form: {
          email: "Email",
          password: "Password",
          button: "Access",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
        },
      },
      companies: {
        title: "Register Company",
        form: {
          name: "Company Name",
          plan: "Plan",
          token: "Token",
          submit: "Register",
          success: "Company successfully created!",
        },
      },

      auth: {
        toasts: {
          success: "Login successful!",
        },
        dueDate: {
          expiration: "Your subscription expires in",
          days: "days!",
          day: "day!",
          expirationToday: "Your subscription expires today!",
        },
        token: "Token",
      },
      dashboard: {
        filters: "Filters",
        filter: "FILTER ",
        tabs: {
          indicators: "Indicators",
          assessments: "NPS",
          attendants: "Agents",
        },
        charts: {
          perDay: {
            title: "Attendances today: ",
          },
        },
        cards: {
          inAttendance: "In Attendance",
          waiting: "Waiting",
          activeAttendants: "Active Agents",
          finalized: "Finalized",
          newContacts: "New Contacts",
          totalReceivedMessages: "Received Messages",
          totalSentMessages: "Sent Messages",
          averageServiceTime: "Average Service Time",
          averageWaitingTime: "Average Waiting Time",
          status: "Status (Current)",
          activeTickets: "Active Tickets",
          passiveTickets: "Passive Tickets",
          groups: "Groups",
        },
        users: {
          name: "Name",
          numberAppointments: "Number of Attendances",
          statusNow: "Current Status",
          totalCallsUser: "Total Attendances per User",
          totalAttendances: "Total Attendances",
        },
        date: {
          initialDate: "Start Date",
          finalDate: "End Date",
        },
        licence: {
          available: "Available until",
        },
        assessments: {
          totalCalls: "Total Attendances",
          callsWaitRating: "Attendances Waiting for Rating",
          callsWithoutRating: "Attendances Without Rating",
          ratedCalls: "Rated Attendances",
          evaluationIndex: "Evaluation Index",
          score: "Score",
          prosecutors: "Promoters",
          neutral: "Neutral",
          detractors: "Detractors",
        },
        ticketStatusFilterValues: {
          open: "Open",
          pending: "Pending",
          closed: "Closed",
          group: "Group",
          chatbot: "Chatbot",
          nps: "NPS",
          lgpd: "LGPD",
        },
      },
      whatsappStatus: {
        title: "WhatsApp Status",
        subtitle: "Create and share your status on WhatsApp",
        selectAccount: "Select WhatsApp Account",
        selectAccountPlaceholder: "WhatsApp Account",
        uploadMedia: "Upload Media",
        image: "Image",
        video: "Video",
        audio: "Audio",
        statusText: "Status Text",
        statusTextPlaceholder: "Write your status here...",
        backgroundColor: "Background Color",
        scheduleForLater: "Schedule for later",
        date: "Date",
        time: "Time",
        repeat: "Repeat",
        noRepeat: "No Repeat",
        daily: "Daily",
        weekly: "Weekly",
        monthly: "Monthly",
        endDate: "End Date",
        scheduleStatus: "Schedule Status",
        sendStatus: "Send Status",
        sending: "Sending...",
        previousStatuses: "Previous Statuses",
        republish: "Republish",
        sent: "Sent",
        failed: "Failed",
        scheduled: "Scheduled",
        pending: "Pending",
        cancelled: "Cancelled",
        noStatuses: "No previous statuses found",
        preview: "Status Preview",
        myStatus: "My Status",
        justNow: "Just now",
        replyToStatus: "Reply to status...",
        previewPlaceholder: "Your status preview will appear here",
        toasts: {
          success: "Status sent successfully!",
          scheduled: "Status scheduled successfully!",
          republished: "Status republished successfully!",
          error: "Error sending status",
          selectWhatsapp: "Select a WhatsApp",
          addContent: "Enter text or select a media",
          fileTooLarge: "File too large. Maximum size:",
          noPermission: "You don't have permission to access this page",
        },
      },
      reports: {
        title: "Research Reports",
        operator: "Operator",
        period: "Period",
        until: "Until",
        date: "Date",
        reportTitle: "Reports",
        calls: "Attendances",
        search: "Surveys",
        durationCalls: "Attendance Duration",
        grupoSessions: "Group Attendances",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Generating compressed report, please wait.",
          errorToast: "Error generating report",
          back: "Back",
          groupServiceReport: "Group Attendance Report",
          loading: "Loading...",
          contact: "Contact",
          dateOpen: "Opening Date",
          dateLastUpdated: "Last Update Date",
          agent: "Agent",
          agentClosed: "Agent who closed",
          waitingAssistance: "Waiting for Service",
          process: "In Service",
        },
        researchReports: {
          response: "Response",
          active: "(Active)",
          inactive: "(Inactive)",
          quantity: "Quantity",
          percentage: "Percentage",
          title: "Research Reports",
          activeSearch: "Active Survey",
          inactiveSearch: "Inactive Survey",
        },
        ticketDurationDetail: {
          msgToast: "Generating compressed report, please wait.",
          title: "Attendance Duration Report",
          startService: "Start of Attendance",
          lastUpdated: "Last Updated",
          lastAgent: "Last Agent",
          durationFinished: "Duration After Closing",
        },
        ticketDuration: {
          title: "Attendance Duration Report",
          contact: "Contact",
          open: "Open",
          pending: "Pending",
          finished: "Finished",
          durationFinished: "Duration of Finished Attendances",
          durationAfterFinished: "Duration After Closing",
          actions: "Actions",
        },
        ticketReports: {
          msgToast: "Generating compressed report, please wait.",
          title: "Attendance Report",
        },
        exportExcel: {
          title: "Attendance Reports",
          startDate: "Start date",
          endDate: "End date",
          notInformed: "Not informed",
          columns: {
            id: "ID",
            connection: "Connection",
            contact: "Contact",
            user: "User",
            queue: "Queue",
            kanban: "Kanban",
            status: "Status",
            lastMessage: "Last Message",
            openDate: "Open Date",
            openTime: "Open Time",
            closeDate: "Close Date",
            closeTime: "Close Time",
            supportTime: "Support Time",
            nps: "NPS",
          },
        },
        pdf: {
          title: "List of Completed Attendances",
          exportTitle: "List of Completed Group Attendances",
        },
      },
      todo: {
        newTask: "New Task",
        add: "Add",
        task: "Tasks",
      },
      contactImportWpModal: {
        title: "Export Contacts to Excel",
        buttons: {
          downloadModel: "Download Excel template for import",
          closed: "Close",
          import: "Select Excel file to import Contacts",
        },
      },
      connections: {
        title: "Connections",
        online: "Online",
        offline: "Offline",
        warning: "Warning",
        check: "Check",
        waitConnection: "Please wait... Your connections will be restarted!",
        newConnection: "New Connection",
        restartConnections: "Restart Connections",
        callSupport: "Call Support",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Connect your service channels to receive messages and start conversations with your customers.",
        client: "Client",
        connectedConnections: "Connected connections",
        disconnectedConnections: "Disconnected connections",
        totalConnections: "Total connections",
        total: "Total",
        connections: " Connections:",
        toasts: {
          deleted: "Connection successfully deleted!",
          closedimported:
            "Closing imported tickets, please wait a few moments.",
        },
        confirmationModal: {
          closedImportedTitle: "Close imported tickets",
          closedImportedMessage:
            "If you confirm, all imported tickets will be closed.",
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone.",
          disconnectTitle: "Disconnect",
          disconnectMessage:
            "Are you sure? You will need to scan the QR Code again.",
        },
        buttons: {
          add: "Add Connection",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          closedImported: "Close all imported tickets",
          preparing: "Preparing messages for import",
          importing: "Importing WhatsApp Messages",
          processed: "Processed",
          in: "of",
          connecting: "Connecting",
        },
        typography: {
          processed: "Processed",
          in: "of",
          date: "Message Date",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Make sure your phone is connected to the internet and try again, or request a new QR Code.",
          },
          qrcode: {
            title: "Waiting for QR Code scan",
            content:
              "Click the 'QR CODE' button and scan the QR Code with your phone to start the session.",
          },
          connected: {
            title: "Connection established!",
          },
          timeout: {
            title: "Connection with the phone was lost",
            content:
              "Make sure your phone is connected to the internet and WhatsApp is open, or click 'Disconnect' to get a new QR Code.",
          },
        },
        table: {
          name: "Name",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
          number: "WhatsApp Number",
          color: "Color",
          receiveComments: "Receive Comments",
        },
        inboundOnlyBadge: "Inbound only",
        receiveComments: {
          enabled: "Comment receiving enabled",
          disabled: "Comment receiving disabled",
          tooltip: {
            enabled: "Comments are being received. Click to disable.",
            disabled: "Comments are not being received. Click to enable.",
          },
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Existing Attendance",
        },
        form: {
          message: "This contact is already being attended to:",
          user: "Agent",
          queue: "Queue",
          messageWait:
            "This contact is already waiting for service. Check the Waiting tab!",
        },
        reusedTicketToast:
          "A conversation for this contact already exists on this connection. Opening the ticket…",
      },
      showTicketLogModal: {
        title: {
          header: "Logs",
        },
        options: {
          create: "Ticket created.",
          chatBot: "ChatBot started.",
          queue: " - Queue assigned.",
          open: " started the service.",
          access: "accessed the ticket.",
          transfered: "transferred the ticket.",
          receivedTransfer: "received the transferred ticket.",
          pending: "returned to the queue.",
          closed: "closed the ticket.",
          reopen: "reopened the ticket.",
          redirect: "- redirected",
          clientClosed: "Client closed the ticket.",
        },
      },
      whatsappModal: {
        title: {
          add: "Add Connection",
          edit: "Edit Connection",
        },
        tabs: {
          general: "General",
          messages: "Messages",
          assessments: "NPS",
          integrations: "Integrations",
          schedules: "Business Hours",
        },
        form: {
          importOldMessagesEnable: "Import messages from device",
          importOldMessages: "Start date of import",
          importRecentMessages: "End date of import",
          importOldMessagesGroups: "Import group messages",
          closedTicketsPostImported: "Close tickets after import",
          name: "Name",
          queueRedirection: "Queue Redirection",
          queueRedirectionDesc:
            "Select a queue for contacts without an assigned queue",
          default: "Default",
          group: "Allow groups",
          inboundOnly: "Inbound only (block first outbound message)",
          inboundOnlyHelper:
            "When enabled, agents cannot start a new ticket or send the first message on this connection. The channel still receives messages, and agents can reply on tickets the customer already opened (or system/flow inbounds).",
          timeSendQueue: "Time in minutes to redirect to queue",
          importAlert:
            "WARNING: Saving will terminate your connection. You will need to scan the QR Code again to import messages.",
          groupAsTicket: "Treat groups as ticket",
          timeCreateNewTicket: "Create a new ticket after X minutes",
          maxUseBotQueues: "Send bot X times",
          maxUseInactiveTime: "Send inactivity flow X times",
          timeUseBotQueues: "Send bot in X minutes",
          timeToReturnQueue: "Time to return to queue in minutes",
          timeAwaitActiveFlow: "Time to wait for active flow",
          expiresTicket: "Close open chats after X minutes",
          expiresTicketNPS: "Close chats awaiting evaluation after X minutes",
          maxUseBotQueuesNPS: "Max times evaluation is sent",
          closeLastMessageOptions1: "From agent/client",
          closeLastMessageOptions2: "From agent only",
          outOfHoursMessage: "Out-of-hours message",
          greetingMessage: "Greeting message",
          complationMessage: "Completion message",
          lgpdLinkPrivacy: "Privacy policy link",
          lgpdMessage: "LGPD greeting message",
          lgpdDeletedMessages: "Obfuscate messages deleted by contact",
          lgpdSendMessage: "Always request contact confirmation",
          ratingMessage: "Evaluation message - Scale must be from 0 to 10",
          token: "Token for external integration",
          sendIdQueue: "Queue",
          inactiveMessage: "Inactivity warning message",
          timeInactiveMessage: "Time in minutes to send inactivity warning",
          flowInactiveTime: "Time in minutes to send inactivity flow",
          whenExpiresTicket: "Close chats when the last message is",
          expiresInactiveMessage: "Inactivity closure message",
          prompt: "Prompt",
          collectiveVacationEnd: "End date",
          collectiveVacationStart: "Start date",
          collectiveVacationMessage: "Collective vacation message",
          queueIdImportMessages: "Queue for message import",
          isOficial: "Official",
          phone_number_id: "Phone Number ID",
          waba_id: "WABA ID",
          send_token: "Sending token",
          business_id: "Business ID (optional)",
          phone_number: "Phone number",
          triggerIntegrationOnClose: "Trigger Integration on Ticket Close",
          triggerIntegrationOnCloseMode: "Action",
          enableIntegration: "Habilited Integration",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        menuItem: {
          enabled: "Enabled",
          disabled: "Disabled",
          triggerIntegrationOnCloseModeAsk: "Ask",
          triggerIntegrationOnCloseModeTrigger: "Trigger",
          minutes: "minutes",
        },
        success: "Connection saved successfully.",
        errorSendQueue:
          "You set a redirection time but no queue was selected. Both fields are required.",
        errorExpiresNPS: "A timeout must be set for NPS evaluation.",
        errorRatingMessage: "An evaluation message must be provided for NPS.",
      },
      qrCode: {
        message: "Scan the QR Code to start the session",
        modalTitle: "Steps to connect",
        step1: "Open WhatsApp on your phone",
        step2: "Tap More options (Android) or Settings (iPhone)",
        step3:
          "Select \"Linked devices\" and then \"Link a device\"",
        step4: "Scan this QR code to confirm",
        hintBelowQr:
          "Point your phone's camera at this screen to capture the code",
        remainingTime: "Time remaining",
        expireSoon:
          "The code expires in a few seconds. If you can't scan in time, request a new QR.",
        expiredHint:
          "This code may have expired. Request a new QR CODE from the connections list.",
        waiting: "Generating code...",
        close: "Close",
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact successfully deleted!",
        },
        searchPlaceholder: "Search...",
        conversationFlows: " Conversation Flows",
        addFlow: "Add Flow",
        editFlow: "Edit Flow ",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import Contacts",
          exportContact: "Export Contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related attendances will be lost.",
          blockContact: "Are you sure you want to block this contact?",
          unblockContact: "Are you sure you want to unblock this contact?",
          importMessage: "Do you want to import all contacts from the phone?",
          importChat: "Import Chats",
          wantImport: "Do you want to import all chats from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
          export: "Export Contact",
        },
        loading: "Loading...",
        loadMore: "Load More",
        table: {
          name: "Name",
          whatsapp: "Connection",
          email: "Email",
          actions: "Actions",
          lastMessage: "Last Message",
        },
        menu: {
          importYourPhone: "Import from default device",
          importToExcel: "Import/Export from Excel",
          importexport: "IMPORT / EXPORT ",
        },
      },
      forwardMessage: {
        text: "Forwarded",
      },
      forwardMessageModal: {
        title: "Forward Message",
        buttons: {
          ok: "Forward",
        },
      },
      promptModal: {
        form: {
          name: "Name",
          prompt: "Prompt",
          voice: "Voice",
          max_tokens: "Maximum Tokens in Response",
          temperature: "Temperature",
          apikey: "API Key",
          max_messages: "Maximum Messages in History",
          voiceKey: "Voice API Key",
          voiceRegion: "Voice Region",
        },
        success: "Prompt saved successfully!",
        title: {
          add: "Add Prompt",
          edit: "Edit Prompt",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Name",
          queue: "Sector/Queue",
          max_tokens: "Max Tokens in Response",
          actions: "Actions",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone!",
        },
        buttons: {
          add: "Add Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Add Contact",
          edit: "Edit Contact",
        },
        form: {
          mainInfo: "Contact Data",
          extraInfo: "Additional Information",
          name: "Name",
          number: "WhatsApp Number",
          email: "Email",
          extraName: "Field Name",
          extraValue: "Value",
          chatBotContact: "Disable Chatbot",
          termsLGDP: "LGPD Terms accepted on:",
          whatsapp: "Origin Connection:",
          situacao: "Status",
          canal: "Channel",
          regiao: "Region",
          campanha: "Campaign",
          produto: "Product",
          filterPlaceholder: "Type to filter...",
          noOptionsMatch: "No matching options",
        },
        buttons: {
          addExtraInfo: "Add Information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
        walletLinked: "Contact linked to your wallet successfully!",
        walletError: "User has no associated queues",
        saveFirst: "Contact must be saved first",
      },
      wallets: {
        title: "Contact Wallets",
        searchPlaceholder: "Search contacts...",
        filterByUser: "Filter by User",
        allUsers: "All users",
        contact: "Contact",
        user: "User",
        queue: "Queue",
        phone: "Phone",
        email: "Email",
        actions: "Actions",
        editWallet: "Edit Wallet",
        selectUser: "Select User",
        selectQueue: "Select Queue",
        selectUserAndQueue: "Select a user and queue",
        cancel: "Cancel",
        save: "Save",
        confirmDeleteTitle: "Confirm Deletion",
        confirmDeleteMessage:
          "Are you sure you want to remove this contact from the wallet?",
        deleteSuccess: "Contact removed from wallet successfully!",
        updateSuccess: "Wallet updated successfully!",
        exportExcel: "Export to Excel",
        exportSuccess: "Spreadsheet exported successfully!",
      },
      queueModal: {
        title: {
          queueData: "Queue Data",
          text: "Business Hours",
          add: "Add Queue",
          edit: "Edit Queue",
          confirmationDelete:
            "Are you sure? All integration options will be deleted.",
        },
        form: {
          name: "Name",
          color: "Color",
          orderQueue: "Queue Order (Bot)",
          rotate: "Rotation",
          timeRotate: "Rotation Time",
          typeRandomMode: "Rotation Type",
          greetingMessage: "Greeting Message",
          complationMessage: "Completion Message",
          outOfHoursMessage: "Out-of-Hours Message",
          token: "Token",
          integrationId: "Integration",
          flowId: "Flow on queue entry",
          flowIdDisabled: "Disabled",
          flowIdHelper:
            "When a ticket is assigned to this queue (menu or transfer), the selected flow starts automatically.",
          fileListId: "File List",
          closeTicket: "Close Ticket",
          queueType: "Menu Type",
          message: "Return Message",
          queue: "Transfer Queue",
          integration: "Integration",
          file: "File List",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        bot: {
          title: "Options",
          toolTipTitle: "Add options to build a chatbot",
          toolTip:
            "If there is only one option, it will be automatically chosen, and the bot will respond with the message and proceed",
          selectOption: "Select an Option",
          text: "Text",
          attendent: "Agent",
          queue: "Queue",
          integration: "Integration",
          file: "File",
          toolTipMessageTitle:
            "Message is required to proceed to the next level",
          toolTipMessageContent:
            "Message is required to proceed to the next level",
          selectUser: "Select a User",
          selectQueue: "Select a Queue",
          selectIntegration: "Select an Integration",
          addOptions: "Add Options",
        },
        serviceHours: {
          dayWeek: "Day of the Week",
          startTimeA: "Start Time - Shift A",
          endTimeA: "End Time - Shift A",
          startTimeB: "Start Time - Shift B",
          endTimeB: "End Time - Shift B",
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
          sunday: "Sunday",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Add Project",
          edit: "Edit Project",
        },
        form: {
          id: "ID",
          type: "Type",
          googleCalendar: "Google Calendar",
          googleClientId: "Client ID (Google Cloud)",
          googleClientSecret: "Client Secret",
          googleClientSecretHintEdit:
            "Loaded when you open edit (authenticated request only). Saving without changing the secret keeps OAuth. Change it only when rotating in Google Cloud — then you must connect again.",
          googleClientSecretHintNew:
            "Required the first time. From Google Cloud → Credentials → your OAuth client.",
          googleCalendarId: "Calendar ID (e.g. primary)",
          googleCalendarIdManualHint:
            "Use the technical calendar ID (e.g. primary or email). After connecting, prefer the list below.",
          googleCalendarReadCalendars: "Include in AI read access",
          googleCalendarWriteCalendar: "Calendar for new events",
          googleCalendarRefreshList: "Refresh calendar list",
          googleCalendarListHint:
            "Choose which calendars the AI may list. Each listed event shows its calendar (cal=) so deletes target the right one.",
          googleCalendarEmptyList:
            "No calendars returned. Check OAuth scopes (reconnect if you just updated the app) or tap «Refresh calendar list».",
          googleCalendarPrimaryBadge: "primary",
          googleCalendarNotInListSuffix: "saved value; not in list",
          googleCalendarOrphanBadge: "saved; not in current list",
          googleTimeZone: "Time zone (IANA)",
          googleOAuthHint:
            "Save with Client ID and Secret first. Then use «Connect with Google» to complete OAuth. The redirect URI shown below must be added in Google Cloud Console.",
          name: "Name",
          projectName: "Project Name",
          language: "Language",
          jsonContent: "JSON Content",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Expiration time in minutes",
          typebotKeywordFinish: "Keyword to finish the ticket",
          typebotKeywordRestart: "Keyword to restart the flow",
          typebotRestartMessage: "Message when restarting the conversation",
          typebotUnknownMessage: "Invalid option message",
          typebotDelayMessage: "Delay (ms) between messages",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          test: "Test Bot",
          connectGoogle: "Connect with Google",
          googleCalendarConnectedBadge: "Connected to Google Calendar",
          googleCalendarConnectedAt: "Confirmed on",
        },
        messages: {
          testSuccess: "Integration tested successfully!",
          addSuccess: "Integration added successfully.",
          editSuccess: "Integration edited successfully.",
          googleCalendarConnected: "Google Calendar connected successfully.",
          googleCalendarError: "Could not complete Google Calendar OAuth.",
          googleCalendarSelectCalendars:
            "Select at least one calendar for read access (or keep your current selection).",
        },
        googleCalendarHelp: {
          aria: "Help: connect Google Calendar",
          title: "Connect Google Calendar",
          linkCloudConsole: "Google Cloud Console",
          linkCalendarApi: "Google Calendar API",
          linkCredentials: "Credentials (OAuth)",
          linkRedirectDoc: "Redirect URI — Google documentation",
          linkAccountPermissions: "Google account connected apps",
          linkFlowBuilder: "Flow Builder",
          step1a: "Open",
          step1b: ", create or select a project.",
          step1c: "Enable the",
          step1d: "Under",
          step1e: ", create an OAuth client ID of type",
          step1f: "Web application",
          step2a:
            "In the OAuth client, under «Authorized redirect URIs», add exactly the URL shown below in this form (ends with",
          step2b: ").",
          step2c: "Official guide:",
          step3a:
            "Enter Client ID and Client Secret, save, then use «Connect with Google». If access fails, revoke the app under",
          step3b: "and try again.",
          step4a: "Open the",
          step4b: ", edit a flow with a GPT or Gemini block and pick this integration under Google Calendar.",
          copyRedirectUri: "Copy redirect URL",
          copyRedirectUriSuccess: "URL copied to clipboard.",
          copyRedirectUriError: "Could not copy. Please copy manually.",
          copyRedirectUriEmpty: "Redirect URL unavailable. Set REACT_APP_BACKEND_URL or save the integration.",
        },
      },
      userModal: {
        warning: "To import messages, you must scan the QR Code again!",
        title: {
          add: "Add User",
          edit: "Edit User",
          updateImage: "Update Image",
          removeImage: "Delete Image",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          farewellMessage: "Farewell Message",
          profile: "Profile",
          startWork: "Work Start Time",
          endWork: "Work End Time",
          whatsapp: "Allowed Connections",
          allTicketEnable: "Enabled",
          allTicketDisable: "Disabled",
          allTicket: "View Tickets Without Queue",
          allowGroup: "Allow Groups",
          defaultMenuOpen: "Open",
          defaultMenuClosed: "Closed",
          defaultMenu: "Default Menu",
          defaultTheme: "Default Theme",
          defaultThemeDark: "Dark",
          defaultThemeLight: "Light",
          allHistoric: "View Conversations from Other Queues",
          allHistoricEnabled: "Enabled",
          allHistoricDisabled: "Disabled",
          allUserChat: "View Other Users' Conversations",
          userClosePendingTicket: "Allow Closing Pending Tickets",
          showDashboard: "View Dashboard",
          allowRealTime: "View Real-Time Panel",
          allowConnections: "Allow Actions on Connections",
          showContacts: "View Contacts",
          showCampaign: "View Campaigns",
          allowWhatsappStatus: "Post Status",
          enabled: "Enabled",
          disabled: "Disabled",
          enableAllPermissions: "Enable all",
        },
        tabs: {
          general: "General",
          permissions: "Permissions",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          addImage: "Add Image",
          editImage: "Edit Image",
        },
        success: "User saved successfully.",
      },
      companyModal: {
        title: {
          add: "Add Company",
          edit: "Edit Company",
        },
        form: {
          name: "Name",
          email: "Email",
          passwordDefault: "Password",
          numberAttendants: "Users",
          numberConections: "Connections",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Company saved successfully.",
      },
      scheduleModal: {
        title: {
          add: "New Schedule",
          edit: "Edit Schedule",
          view: "Schedule details",
          message: "Message",
        },
        form: {
          body: "Message",
          contact: "Contact",
          sendAt: "Scheduled Date",
          sentAt: "Sent Date",
          assinar: "Send Signature",
          oficialTemplate: "Approved template (Official API)",
          oficialTemplateHelper: "Only Meta-approved templates can be used. Free text, attachments, quick replies, and reminders are disabled.",
          oficialEmptyTemplates: "No approved template found for this connection",
          oficialTemplateLoading: "Loading templates…",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          addSchedule: "Add Schedule",
        },
        success: "Schedule saved successfully.",
      },
      tagModal: {
        title: {
          add: "New Tag",
          edit: "Edit Tag",
          addKanban: "New Lane",
          editKanban: "Edit Lane",
          backToKanban: "BACK TO KANBAN",
        },
        form: {
          name: "Name",
          color: "Color",
          timeLane: "Time in minutes to redirect to lane",
          nextLaneId: "Lane",
          greetingMessageLane: "Lane Greeting Message",
          mediaFiles: "Media",
          rollbackLaneId: "Return to Lane after resuming attendance",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Tag saved successfully.",
        successKanban: "Lane saved successfully.",
      },
      fileModal: {
        title: {
          add: "Add File List",
          edit: "Edit File List",
        },
        buttons: {
          okAdd: "Save",
          okEdit: "Edit",
          cancel: "Cancel",
          fileOptions: "Add File",
        },
        form: {
          name: "File List Name",
          message: "List Details",
          fileOptions: "File List",
          extraName: "Message to send with file",
          extraValue: "Option Value",
        },
        success: "File list saved successfully!",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "⬇️ DRAG AND DROP FILES BELOW ⬇️",
          titleFileList: "File List",
        },
      },
      chatInternal: {
        new: "New group",
        modal: {
          conversation: "Conversation",
          title: "Title",
          filterUsers: "Filter by Users",
          cancel: "Close",
          save: "Save",
        },
        modalDelete: {
          title: "Delete Conversation",
          message: "This action cannot be undone, confirm?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "DO YOU WANT TO CLOSE ALL TICKETS?",
        yes: "YES",
        not: "NO",
        buttons: {
          newTicket: "New",
          resolveAll: "Resolve All",
          close: "Close",
          new: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
      },
      tickets: {
        inbox: {
          closedAllTickets: "Close all tickets?",
          closedAllTicketsDescription: "Are you sure you want to close all tickets from this tab?",
          closedAll: "Close All",
          newTicket: "New Ticket",
          yes: "YES",
          no: "NO",
          open: "Open",
          resolverd: "Resolved",
        },
        toasts: {
          deleted: "The attendance you were handling has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Open" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search attendance and messages",
          filterConections: "Filter by Connection",
          filterConectionsOptions: {
            open: "Open",
            closed: "Closed",
            pending: "Pending",
          },
          filterUsers: "Filter by Users",
          filterContacts: "Filter by Contacts",
          ticketsPerPage: "Tickets per page",
          filtersApplied: "Applied Filters",
          clearFilters: "Clear Filters",
        },
        buttons: {
          showAll: "All",
          returnQueue: "Return to Queue",
          scredule: "Schedule",
          deleteTicket: "Delete Ticket",
        },
        closedTicket: {
          closedMessage: "Close Ticket With Farewell Message",
          closedNotMessage: "Close Ticket Without Farewell Message",
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to Queue",
        fieldQueuePlaceholder: "Select a queue",
        fieldWhatsapp: "Select a WhatsApp",
        noOptions: "No users found with that name",
        msgTransfer: "Notes - internal message, will not be sent to the client",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      chatInternal: {
        new: "New group",
        modal: {
          conversation: "Conversation",
          title: "Title",
          filterUsers: "Filter by Users",
          cancel: "Close",
          save: "Save",
        },
        modalDelete: {
          title: "Delete Conversation",
          message: "This action cannot be undone, confirm?",
        },
      },
      ticketsList: {
        called: "Call",
        today: "Today",
        missedCall: "Missed voice/video call at",
        pendingHeader: "Waiting",
        assignedHeader: "In Attendance",
        groupingHeader: "Groups",
        closedHeader: "Resolved",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage:
          "No attendances found with this status or search term",
        noQueue: "No Queue",
        sortUnreadFirst: "Unread first",
        sortByDate: "By date",
        buttons: {
          accept: "Accept",
          cancel: "Cancel",
          start: "Start",
          closed: "Close",
          reopen: "Reopen",
          transfer: "Transfer",
          ignore: "Ignore",
          exportAsPDF: "Export to PDF",
          kanbanActions: "Kanban Options",
        },
        acceptModal: {
          title: "Accept Chat",
          queue: "Select Sector",
        },
        actions: {
          newTicket: "New ticket",
          search: "Search",
          showMyTickets: "Show my tickets",
          showAll: "Show all",
          openFilters: "Open Filters",
          closeFilters: "Close Filters",
          closeAllTickets: "Close all tickets",
          searchButton: "Search",
          clearSearch: "Clear Search",
          searchInMessages: "Search in message content",
          appliedFilters: "Applied Filters",
          clearAllFilters: "Clear all filters",
          clearFilters: "Clear Filters",
          clear: "Clear",
          newAttendance: "New Attendance",
          resolved: "Resolved",
          newestFirst: "Newest first",
          oldestFirst: "Oldest first",
          selectTicket: "Select Ticket",
          attendances: "Attendances",
        },
        ticketMessageSearchModal: {
          title: "Messages in this ticket",
          resultsSuffix: "match(es) in this ticket",
          empty: "No messages found in this ticket.",
          close: "Close",
          you: "You",
          contactUnknown: "Contact not identified",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search for a contact",
        add: "Add",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      SendContactModal: {
        title: "Send Contact",
        fieldLabel: "Type to search for contact",
        add: "Add",
        buttons: {
          ok: "Send",
          cancel: "Cancel",
        },
      },
      customContactFieldsPage: {
        title: "Custom contact fields",
        subtitle:
          "Manage Situation, Channel and Region values used in filters and contact forms.",
        subtitleExtended:
          "Create field groups by type (text, number or list). Situation, Channel and Region are initial groups; you can add more. List values are select options.",
        newGroup: "New group",
        newGroupTitle: "New field group",
        editGroupTitle: "Edit group",
        editGroup: "Edit group",
        deleteGroup: "Delete group",
        groupParam: "Identifier (code)",
        groupParamHelp:
          "E.g. LEAD_SOURCE — letters and numbers, no spaces. Cannot be changed later.",
        groupLabel: "Display name",
        groupLabelRequired: "Enter the group name.",
        groupParamRequired: "Enter a valid identifier for the group.",
        groupCreateSuccess: "Group created successfully.",
        groupUpdateSuccess: "Group updated successfully.",
        groupDeleteSuccess: "Group removed.",
        cannotDeleteLegacyGroup:
          "Situation, Channel and Region groups cannot be deleted.",
        confirmDeleteGroupTitle: "Delete group",
        confirmDeleteGroup:
          "Deletes the group definition and all associated list options. Values already saved on contacts are not removed automatically.",
        fieldKind: "Field type",
        multiMax: "Maximum selections",
        multiMaxRequired:
          "Enter the limit (number) for limited multi-select.",
        sortOrder: "Tab order",
        tabFreeInput: "free text",
        freeFieldHint:
          "This type does not use a list of options here. The value is entered freely on the contact form.",
        optionsOnlyForSelect: "List options only apply to select field types.",
        noGroups: "No groups registered.",
        fieldKinds: {
          text: "Free text",
          number: "Numbers only",
          selectSingle: "List — single choice",
          selectMulti: "List — multiple choices",
          selectMultiLimited: "List — multiple (limited)",
        },
        add: "Add",
        loading: "Loading...",
        empty: "No values registered for this tab.",
        value: "Value",
        actions: "Actions",
        addTitle: "Add value",
        editTitle: "Edit value",
        cancel: "Cancel",
        save: "Save",
        tabSituacao: "Situation",
        tabCanal: "Channel",
        tabRegiao: "Region",
        valueRequired: "Enter a value to continue.",
        successCreate: "Value created successfully.",
        successUpdate: "Value updated successfully.",
        successDelete: "Value removed successfully.",
        confirmDeleteTitle: "Delete value",
        confirmDelete: "Are you sure you want to delete this value?",
        groupsApiFallback:
          "Could not load field groups (check migrations and API deploy). Showing Situation, Channel and Region in compatibility mode; list values still load.",
        cannotEditFallbackGroup:
          "Fixed groups cannot be edited in compatibility mode. After migrating the database, reload the page.",
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connections",
          chatsTempoReal: "Real-Time Panel",
          tickets: "Attendances",
          quickMessages: "Quick Replies",
          contacts: "Contacts",
          wallets: "Wallets",
          queues: "Queues & Chatbot",
          tags: "Tags",
          dashboardTags: "Tags Dashboard",
          administration: "Administration",
          companies: "Companies",
          users: "Users",
          birthdaySettings: "Birthday Settings",
          settings: "Settings",
          files: "File Lists",
          helps: "Help Center",
          apisSubmenu: "APIs",
          messagesAPI: "API",
          apiOficialDocs: "Official API",
          testInteractive: "Test buttons/list",
          schedules: "Schedules",
          campaigns: "Campaigns",
          annoucements: "Announcements",
          chats: "Internal Chat",
          financeiro: "Financial",
          queueIntegration: "Integrations",
          version: "Version",
          kanban: "Kanban",
          prompts: "Talk.AI",
          allConnections: "Manage Connections",
          reports: "Reports",
          management: "Management",
          automations: "Automations",
          auditLogs: "Audit Logs",
          groupManagement: "Group Management",
          callHistorical: "Call History",
          customContactFields: "Custom contact fields",
          tasks: "Tasks",
          browserNotifications: "Browser notifications",
          whatsappTemplates: "Meta templates",
          status: "Status",
        },
        appBar: {
          user: {
            profile: "Profile",
            logout: "Logout",
            message: "Hello",
            messageEnd: "welcome to",
            active: "Active until",
            goodMorning: "Hi,",
            myName: "my name is",
            continuity: "and I will continue your service.",
            virtualAssistant: "Virtual Assistant",
            token: "Invalid token, please contact the platform administrator.",
          },
          message: {
            location: "Location",
            contact: "Contact",
          },
          language: "Language",
          theme: {
            light: "Light Mode",
            dark: "Dark Mode",
          },
          notRegister: "No records found",
          refresh: "Refresh",
        },
      },
      languages: {
        undefined: "Language",
        "pt-BR": "Portuguese",
        es: "Spanish",
        en: "English",
        tr: "Turkish",
      },
      apiOficialDocs: {
        title: "Official WhatsApp API (Meta)",
        intro: "Documentation for sending messages via WhatsApp Business API from Meta. Use the WhatsApp Official connection token in all requests.",
        baseUrl: "Base URL",
        auth: "Authentication",
        authDesc: "All requests require the Authorization header with the WhatsApp Official connection token.",
        authHeader: "Header:",
        endpoints: "Available endpoints",
        postmanTitle: "Postman Collection",
        postmanDesc: "Download the full collection to import into Postman and test all routes.",
        downloadPostman: "Download Postman Collection",
        notesTitle: "Notes",
        note1: "Normal messages (text, image, audio, video, document) require an active 24h window.",
        note2: "Templates can be sent at any time, without the 24h window.",
        note3: "The number must be sent without mask (e.g. 5511999998888).",
        sections: {
          send: "Message sending",
          media: "Upload and media",
          templates: "Templates",
          verification: "Verification",
        },
        endpointsDesc: {
          sendText: "Send text message.",
          sendImage: "Send image (file, URL or mediaId).",
          sendAudio: "Send audio.",
          sendVideo: "Send video.",
          sendDocument: "Send document.",
          sendTemplate: "Send template (no 24h window required).",
          uploadMedia: "Upload media to Meta (returns media_id).",
          mediaLimits: "Returns media limits by type.",
          listTemplates: "List approved templates.",
          validateTemplate: "Validate template before sending.",
          checkWindow: "Check if number is within 24h window.",
        },
        examplesTitle: "Request examples",
        exampleSendText: "Send text",
        exampleSendTemplate: "Send template",
        exampleGetTemplates: "List templates",
        testTitle: "Try it out",
        testDesc: "Enter the WhatsApp Official connection token and optionally number/body. Click Send to execute the request.",
        testEndpoint: "Endpoint",
        testToken: "Token (required)",
        testNumber: "Number (e.g. 5511999998888)",
        testBody: "Body (JSON)",
        testSend: "Send",
        testResponse: "Response",
        testStatus: "Status",
        testLoading: "Sending...",
      },
      messagesAPI: {
        title: "API",
        toSend: "TO SEND",
        textMessage: {
          number: "Number",
          body: "Message",
          token: "Registered Token",
          userId: "User/Agent ID",
          queueId: "Queue ID",
        },
        mediaMessage: {
          number: "Number",
          body: "File Name",
          media: "File",
          token: "Registered Token",
        },
        API: {
          title: "Message Sending Documentation",
          methods: {
            title: "Sending Methods",
            messagesText: "Text Messages",
            messagesMidia: "Media Messages",
          },
          instructions: {
            title: "Instructions",
            comments: "Important Notes",
            comments1:
              "Before sending messages, it is necessary to register the token linked to the connection that will send the messages. <br />To register, access the 'Connections' menu, click the edit button on the connection, and insert the token in the appropriate field.",
            comments2:
              "The sending number must not have a mask or special characters and must be composed of:",
            codeCountry: "Country Code",
            code: "Area Code (DDD)",
            number: "Phone Number",
          },
          text: {
            title: "1. Text Messages",
            instructions:
              "Below is the list of required information to send text messages:",
          },
          media: {
            title: "2. Media Messages",
            instructions:
              "Below is the list of required information to send media messages:",
          },
        },
      },
      notifications: {
        noTickets: "No notifications.",
        transferTitle: "Ticket transferred:",
        transferReceived: "You received a transferred ticket",
      },
      quickMessages: {
        title: "Quick Replies",
        searchPlaceholder: "Search...",
        noAttachment: "No attachment",
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action is irreversible! Do you want to proceed?",
        },
        buttons: {
          add: "Add",
          attach: "Attach File",
          cancel: "Cancel",
          edit: "Edit",
        },
        toasts: {
          success: "Shortcut added successfully!",
          deleted: "Shortcut removed successfully!",
        },
        dialog: {
          title: "Quick Message",
          shortcode: "Shortcut",
          message: "Response",
          save: "Save",
          cancel: "Cancel",
          general: "General",
          geral: "Allow Editing",
          add: "Add",
          edit: "Edit",
          visao: "Allow Viewing",
        },
        table: {
          shortcode: "Shortcut",
          message: "Message",
          actions: "Actions",
          mediaName: "File Name",
          status: "Status",
        },
      },
      contactLists: {
        title: "Contact Lists",
        table: {
          name: "Name",
          contacts: "Contacts",
          actions: "Actions",
        },
        buttons: {
          add: "New List",
        },
        dialog: {
          name: "Name",
          company: "Company",
          okEdit: "Edit",
          okAdd: "Add",
          add: "Add",
          edit: "Edit",
          cancel: "Cancel",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          deleted: "Record deleted successfully.",
        },
      },
      contactListItems: {
        title: "Contacts",
        searchPlaceholder: "Search",
        buttons: {
          add: "New",
          lists: "Lists",
          import: "Import",
        },
        dialog: {
          name: "Name",
          number: "Number",
          whatsapp: "WhatsApp",
          email: "Email",
          okEdit: "Edit",
          okAdd: "Add",
          add: "Add",
          edit: "Edit",
          cancel: "Cancel",
        },
        table: {
          name: "Name",
          number: "Number",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
          importMessage:
            "Do you want to import the contacts from this spreadsheet?",
          importTitlte: "Import",
        },
        toasts: {
          deleted: "Record deleted successfully.",
        },
      },
      kanban: {
        title: "Kanban",
        laneTicketCountTooltip: "Tickets in this lane: {{count}}",
        laneTicketCountAria: "{{count}} tickets in this lane",
        assignValue: "Assign value",
        removeAssignedValue: "Remove assigned value",
        filterByUser: "Filter by User",
        filterByConnection: "Filter by Connection",
        filterAll: "All",
        showClosed: "Show closed",
        ticketClosed: "Closed",
        searchPlaceholder: "Search",
        subMenus: {
          list: "Board",
          tags: "Lanes",
        },
        showingCardsPartial: "Showing {{visible}} of {{total}} cards (load more to see the rest).",
        loadMoreCards: "Load more cards",
      },
      campaigns: {
        title: "Campaigns",
        searchPlaceholder: "Search",
        subMenus: {
          list: "Listing",
          listContacts: "Contact List",
          settings: "Settings",
        },
        settings: {
          randomInterval: "Random Sending Interval",
          noBreak: "No Interval",
          intervalGapAfter: "Longer interval after",
          undefined: "Undefined",
          messages: "messages",
          laggerTriggerRange: "Larger Sending Interval",
          addVar: "Add Variable",
          save: "Save",
          close: "Close",
          add: "Add",
          shortcut: "Shortcut",
          content: "Content",
        },
        buttons: {
          add: "New Campaign",
          contactLists: "Contact Lists",
        },
        table: {
          name: "Name",
          whatsapp: "Connection",
          contactList: "Contact List",
          option: "None",
          disabled: "Disabled",
          enabled: "Enabled",
          status: "Status",
          scheduledAt: "Scheduled",
          completedAt: "Completed",
          confirmation: "Confirmation",
          actions: "Actions",
        },
        dialog: {
          new: "New Campaign",
          update: "Edit Campaign",
          readonly: "View Only",
          help: "Use variables like {name}, {number}, {email}, or define custom variables.",
          form: {
            name: "Name",
            message1: "Message 1",
            message2: "Message 2",
            message3: "Message 3",
            message4: "Message 4",
            message5: "Message 5",
            confirmationMessage1: "Confirmation Message 1",
            confirmationMessage2: "Confirmation Message 2",
            confirmationMessage3: "Confirmation Message 3",
            confirmationMessage4: "Confirmation Message 4",
            confirmationMessage5: "Confirmation Message 5",
            messagePlaceholder: "Message content",
            whatsapp: "Connection",
            status: "Status",
            scheduledAt: "Schedule",
            confirmation: "Confirmation",
            contactList: "Contact List",
            tagList: "Tags",
            statusTicket: "Ticket Status",
            openTicketStatus: "Open",
            pendingTicketStatus: "Pending",
            closedTicketStatus: "Closed",
            enabledOpenTicket: "Enabled",
            disabledOpenTicket: "Disabled",
            openTicket: "Open Ticket",
          },
          buttons: {
            add: "Add",
            edit: "Update",
            okadd: "Ok",
            cancel: "Cancel Sending",
            restart: "Restart Sending",
            close: "Close",
            attach: "Attach File",
          },
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          success: "Operation completed successfully.",
          cancel: "Campaign canceled.",
          restart: "Campaign restarted.",
          deleted: "Record deleted successfully.",
        },
      },
      campaignReport: {
        title: "Campaign Report",
        inactive: "Inactive",
        scheduled: "Scheduled",
        process: "In Progress",
        cancelled: "Canceled",
        finished: "Completed",
        campaign: "Campaign",
        validContacts: "Valid Contacts",
        confirmationsRequested: "Confirmations Requested",
        confirmations: "Confirmations",
        deliver: "Delivered",
        connection: "Connection",
        contactLists: "Contact List",
        schedule: "Schedule",
        conclusion: "Conclusion",
      },
      announcements: {
        title: "Announcements",
        searchPlaceholder: "Search",
        active: "Active",
        inactive: "Inactive",
        buttons: {
          add: "New Announcement",
          contactLists: "Announcement Lists",
        },
        table: {
          priority: "Priority",
          title: "Title",
          text: "Text",
          mediaName: "File",
          status: "Status",
          actions: "Actions",
        },
        dialog: {
          edit: "Edit Announcement",
          add: "New Announcement",
          update: "Edit Announcement",
          readonly: "View Only",
          form: {
            priority: "Priority",
            title: "Title",
            text: "Text",
            mediaPath: "File",
            status: "Status",
            high: "High",
            medium: "Medium",
            low: "Low",
            active: "Active",
            inactive: "Inactive",
          },
          buttons: {
            add: "Add",
            edit: "Update",
            okadd: "Ok",
            cancel: "Cancel",
            close: "Close",
            attach: "Attach File",
          },
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          success: "Operation completed successfully.",
          deleted: "Record deleted successfully.",
        },
      },
      campaignsConfig: {
        title: "Campaign Settings",
      },
      queues: {
        title: "Queues & Chatbot",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting Message",
          orderQueue: "Queue Order (Bot)",
          actions: "Actions",
          ID: "ID",
        },
        buttons: {
          add: "Add Queue",
        },
        toasts: {
          success: "Queue saved successfully.",
          deleted: "Queue deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? This action cannot be undone! Attendances from this queue will still exist but will no longer be assigned to a queue.",
        },
      },
      queue: {
        queueData: "Queue Data",
      },
      queueSelect: {
        inputLabel: "Queues",
        inputLabelRO: "Read-Only Queues",
        withoutQueue: "No Queue",
      },
      whatsappSelect: {
        inputLabel: "Allowed Connections",
      },
      reports: {
        title: "Attendance Reports",
        startDate: "Start date ",
        endDate: "End date",

        table: {
          id: "Ticket",
          user: "User",
          dateOpen: "Opening Date",
          dateClose: "Closing Date",
          NPS: "NPS",
          status: "Status",
          whatsapp: "Connection",
          queue: "Queue",
          actions: "Actions",
          lastMessage: "Last Message",
          contact: "Customer",
          supportTime: "Attendance Time",
        },
        buttons: {
          filter: "Apply Filter",
          onlyRated: "Only Rated",
          exportExcel: "Download Excel",
        },
        searchPlaceholder: "Search...",
        kanbanLane: "Kanban",
        kanbanLaneAll: "All lanes",
      },
      queueIntegration: {
        title: "Integrations",
        table: {
          id: "ID",
          type: "Type",
          name: "Name",
          projectName: "Project Name",
          language: "Language",
          lastUpdate: "Last Update",
          actions: "Actions",
        },
        buttons: {
          add: "Add Project",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? This action cannot be undone and will be removed from linked queues and connections.",
        },
      },
      users: {
        title: "Users",
        table: {
          status: "Status",
          name: "Name",
          email: "Email",
          profile: "Profile",
          startWork: "Work Start Time",
          endWork: "Work End Time",
          actions: "Actions",
          ID: "ID",
        },
        buttons: {
          add: "Add User",
        },
        toasts: {
          deleted: "User deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Open tickets for this user will be moved to the queue.",
        },
      },
      compaies: {
        title: "Companies",
        table: {
          ID: "ID",
          status: "Active",
          name: "Name",
          email: "Email",
          password: "Password",
          phone: "Phone",
          plan: "Plan",
          active: "Active",
          numberAttendants: "Agents",
          numberConections: "Connections",
          value: "Value",
          namePlan: "Plan Name",
          numberQueues: "Queues",
          useCampaigns: "Campaigns",
          useExternalApi: "REST API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "WhatsApp",
          useInternalChat: "Internal Chat",
          useSchedules: "Scheduling",
          createdAt: "Created At",
          dueDate: "Expiration Date",
          lastLogin: "Last Login",
          folderSize: "Folder size ",
          totalFiles: " Total Files",
          lastUpdate: "Last update",
          actions: "Actions",
          money: "$",
          yes: "Yes",
          no: "No",
          document: "CNPJ/CPF",
          recurrence: "Recurrence",
          monthly: "Monthly",
          bimonthly: "Bimonthly",
          quarterly: "Quarterly",
          semester: "Semiannual",
          yearly: "Annual",
          clear: "Clear",
          delete: "Delete",
          user: "User",
          save: "Save",
        },
        buttons: {
          add: "Add Company",
        },
        toasts: {
          deleted: "Company deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All company data will be lost. Open tickets for users in this company will be moved to the queue.",
        },
      },
      plans: {
        form: {
          name: "Name",
          users: "Users",
          connections: "Connections",
          campaigns: "Campaigns",
          schedules: "Schedules",
          groupManagement: "Group Management",
          whatsappMeow: "WhatsMeow (WuzAPI)",
          conecthub360: "Conecthub 360",
          useTelegram: "Telegram",
          telegramSetupTitle: "Telegram — server setup (master user)",
          telegramSetupBody:
            "1) Create an app at my.telegram.org/apps and set on the backend .env: TELEGRAM_API_ID and TELEGRAM_API_HASH (one pair for the whole installation). Restart the backend (PM2) after saving.\n2) Enable «Telegram» on this plan to allow connections.\n3) Bot (@BotFather): each bot uses its own token — no .env API ID/Hash needed.\n4) Personal account (MTProto): Connections → Telegram personal — uses .env variables.",
          telegramPlanHint: "Enables Bot @BotFather and personal account (MTProto) on this plan.",
          conecthubOpen: "Open ConectHUB",
          conecthubPublicLink: "ConectHUB 360 public link",
          conecthubPublicLinkSave: "Save link",
          conecthubPublicLinkToastOk: "ConectHUB settings saved for master company.",
          conecthubPublicLinkToastErr: "Could not save ConectHUB settings.",
          conecthubAccountId: "Account ID (ConectHUB)",
          conecthubMessagingApiKey: "API Key (ConectHUB messaging)",
          conecthubMessagingApiKeyHint:
            "Key for the hub messaging API (X-API-Key header). Master company only.",
          enabled: "Enabled",
          disabled: "Disabled",
          clear: "Cancel",
          delete: "Delete",
          save: "Save",
          yes: "Yes",
          no: "No",
          money: "$",
          public: "Public",
          trial: "Trial",
          trialDays: "Trial Days",
          phraseListFlow: "Campaign flow (phrase lists)",
          conversationFlow: "Conversation flow (flowbuilder)",
          followUpFlow: "Follow UP (templates)",
          phraseListFlowShort: "Camp. flow",
          conversationFlowShort: "Conv. flow",
          followUpFlowShort: "Follow UP",
        },
      },
      helps: {
        title: "Help Center",
        settings: {
          codeVideo: "Video Code",
          description: "Description",
          clear: "Clear",
          delete: "Delete",
          save: "Save",
        },
      },
      schedules: {
        title: "Schedules",
        date: "Date",
        time: "Time",
        event: "Event",
        allDay: "All Day",
        week: "Week",
        work_week: "Work Week",
        day: "Day",
        month: "Month",
        previous: "Previous",
        next: "Next",
        yesterday: "Yesterday",
        tomorrow: "Tomorrow",
        today: "Today",
        agenda: "Agenda",
        noEventsInRange: "No events in this range.",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Schedule?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          contact: "Contact",
          body: "Message",
          sendAt: "Scheduled Date",
          sentAt: "Sent Date",
          status: "Status",
          actions: "Actions",
        },
        buttons: {
          add: "New Schedule",
        },
        toasts: {
          deleted: "Schedule deleted successfully.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ ADD COLUMNS",
        search: "SEARCH",
        seeTicket: "SEE TICKET",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Tag?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          id: "ID",
          name: "Name",
          kanban: "Kanban",
          color: "Color",
          tickets: "Tag Records",
          contacts: "Contacts",
          actions: "Actions",
        },
        buttons: {
          add: "New Tag",
        },
        toasts: {
          deleted: "Tag deleted successfully.",
        },
      },
      tagsKanban: {
        title: "Lanes",
        laneDefault: "Open",
        backToKanban: "BACK TO KANBAN",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Lane?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          name: "Name",
          color: "Color",
          tickets: "Tickets",
          actions: "Actions",
        },
        buttons: {
          add: "New Lane",
        },
        toasts: {
          deleted: "Lane deleted successfully.",
        },
      },
      files: {
        title: "File Lists",
        table: {
          name: "Name",
          contacts: "Contacts",
          actions: "Action",
        },
        toasts: {
          deleted: "File list deleted successfully!",
          deletedAll: "All file lists were deleted successfully!",
        },
        buttons: {
          add: "Add",
          deleteAll: "Delete All",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteAllTitle: "Delete All",
          deleteMessage: "Are you sure you want to delete this list?",
          deleteAllMessage: "Are you sure you want to delete all lists?",
        },
      },
      holidays: {
        title: "Recurring Holidays",
        infoText: "Recurring holidays - valid for any year. When a message is received on an active holiday day, the holiday description will be sent automatically.",
        table: {
          dayMonth: "Day/Month",
          description: "Description",
          status: "Status",
          statusActive: "Active",
          statusInactive: "Inactive",
          actions: "Actions",
        },
        buttons: {
          add: "Add",
        },
        modal: {
          createTitle: "New Holiday",
          editTitle: "Edit Holiday",
          month: "Month",
          day: "Day",
          description: "Holiday Description",
          descriptionPlaceholder: "Ex: Independence Day",
          isActive: "Active Holiday",
          save: "Save",
          create: "Create",
          cancel: "Cancel",
          infoText: "This holiday will be valid for any year (2025, 2026, 2027...)",
        },
        confirmationModal: {
          deleteTitle: "Delete Holiday",
          deleteMessage: "Do you really want to delete the holiday",
        },
        toasts: {
          created: "Holiday created successfully!",
          updated: "Holiday updated successfully!",
          deleted: "Holiday deleted successfully!",
        },
        empty: "No holidays registered",
      },
      groupManagement: {
        title: "WhatsApp Group Management",
        selectConnection: "Select connection",
        listGroups: "List groups",
        listGroupsDescription: "View all groups for this connection",
        createGroup: "Create group",
        createGroupDescription: "Create new group and add participants",
        broadcast: "Broadcast",
        broadcastDescription: "Send message to multiple groups",
        editGroup: "Edit group",
        editGroupDescription: "Change data and participants of groups where you are admin",
        editGroupAdminOnlyHint: "Only groups where this number is an administrator are listed.",
        editGroupListHint: "Groups for this connection are listed. Only groups where this number is an administrator can be edited.",
        tabGroupInfo: "Group info",
        noAdminGroups: "No groups where you are an administrator.",
        saveGroup: "Save changes",
        groupUpdated: "Group updated successfully.",
        editGroupParticipants: "Add or remove participants",
        noConnections: "No connections available",
        noConnectionsTitle: "No group management connections",
        noConnectionsHint: "Connect a WhatsApp (Baileys or WhatsMeow) to use group management.",
        back: "Back",
        groupName: "Group name",
        groupNamePlaceholder: "e.g. My Group",
        groupDescription: "Group description",
        groupDescriptionPlaceholder: "Text shown on the group info page (optional)",
        groupCoverPhoto: "Cover photo",
        addCoverPhoto: "Click or drag an image",
        changeCoverPhoto: "Click to change cover photo",
        currentCover: "Current cover",
        removeCover: "Remove cover",
        coverMustBeImage: "Please select an image file (JPG, PNG, etc.).",
        participantsCount: "Participants",
        actions: "Actions",
        seeParticipants: "See participants",
        leaveGroup: "Leave group",
        leaveGroupConfirm: "Leave group \"{{name}}\"? You will stop receiving messages.",
        leaveGroupOthersRemain: "Other participants will remain in the group. WhatsApp does not allow deleting the group for everyone.",
        deleteGroup: "Delete group",
        deleteGroupTitle: "Delete group",
        deleteGroupConfirmMessage: "To confirm deletion of group \"{{name}}\", type DELETE below.",
        deleteGroupTypePlaceholder: "Type DELETE",
        deleteGroupConfirmWord: "DELETE",
        noGroups: "No groups found.",
        participants: "Participants",
        nameRequired: "Enter the group name.",
        groupCreated: "Group created successfully.",
        create: "Create",
        participantName: "Name",
        participantNumber: "Number",
        admin: "Admin",
        noParticipants: "No participants.",
        addParticipant: "Add",
        removeParticipant: "Remove participant",
        participantNumberRequired: "Enter the participant number.",
        participantAdded: "Participant added.",
        participantRemoved: "Participant removed.",
        removeSelected: "Remove selected",
        participantsRemoved: "{{count}} participant(s) removed.",
        selectAtLeastOneParticipant: "Select at least one participant.",
        generateCampaign: "Generate campaign",
        listFromGroup: "List from Group",
        chooseCampaignType: "Choose campaign type",
        chooseCampaignTypeHint: "A list will be created in PRO Campaigns with the selected contacts. Then open the desired campaign.",
        campaignPro: "PRO Campaign",
        campaignOfficial: "Official Campaign",
        creatingList: "Creating list...",
        creatingListHint: "Adding contacts to the list. Please wait.",
        exportCsv: "Export CSV",
        normalizingTitle: "Normalizing participants",
        normalizingProgress: "Resolving contact names and numbers. This may take up to 1 minute.",
        validatingContactCount: "Validating contact {{current}} of {{total}}",
        importMapping: "Import mapping",
        importMappingTitle: "LID → Name/Number mapping",
        importMappingHint: "Paste a CSV with columns: lid;number;name (one row per participant). LID is the ID shown in the list when the number is unknown.",
        importMappingPlaceholder: "E.g.: 68899982856277;5511999999999;John Doe",
        importMappingSuccess: "Mapping imported: {{created}} new, {{updated}} updated.",
        importMappingError: "Error importing mapping.",
        cancel: "Cancel",
        selectGroupsToSend: "Select groups to send the message",
        selectAll: "Select all",
        searchGroups: "Search by name",
        message: "Message",
        sendBroadcast: "Send",
        attachMedia: "Attach media",
        sendMedia: "Send media",
        mediaImage: "Image",
        mediaVideo: "Video",
        mediaAudio: "Audio",
        mediaDocument: "Document",
        removeMedia: "Remove media",
        messageCaptionHint: "Optional: caption for the media",
        messageOrMediaRequired: "Enter text and/or attach a media (image, audio or PDF).",
        results: "Result per group",
        previewTitle: "Real-time preview",
        previewEmpty: "Type your message to see the preview",
        leftGroup: "You left the group.",
        selectGroupsAndMessage: "Select at least one group and enter the message.",
        broadcastSent: "Sent: {{count}} of {{total}} groups.",
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        tabs: {
          options: "Options",
          layout: "Layout",
          plans: "Plans",
          helps: "Help",
          companies: "Companies",
        },
        layout: {
          title: "System Layout",
          description: "Choose the layout style you prefer for the system. The modern layout offers faster navigation with a horizontal menu.",
          save: "Save and Apply",
          classic: {
            title: "Classic Layout",
            description: "Traditional side menu, ideal for those who prefer vertical navigation.",
          },
          modern: {
            title: "Modern Layout",
            description: "Horizontal menu at the top, modern design and faster navigation.",
          },
        },
        settings: {
          userCreation: {
            name: "User Creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          tabs: {
            options: "Options",
            schedules: "Schedules",
            plans: "Plans",
            help: "Help",
          },
          options: {
            disabled: "Disabled",
            enabled: "Enabled",
            ask: "Ask",
            askGreetingConfirm: "Do you want to send the greeting message?",
            updating: "Updating...",
            creationCompanyUser: "Company/User Creation",
            evaluations: "Evaluations",
            officeScheduling: "Office Scheduling",
            queueManagement: "Queue Management",
            companyManagement: "Company Management",
            connectionManagement: "Connection Management",
            sendGreetingAccepted: "Send Greeting on Accepting Ticket",
            sendMsgTransfTicket:
              "Send Transfer Message between Departments/Agents",
            checkMsgIsGroup: "Ignore Group Messages",
            chatBotType: "Bot Type",
            chatBotTypeText: "Text",
            chatBotTypeButton: "Buttons",
            chatBotTypeList: "List",
            userRandom: "Random Agent Selection",
            buttons: "Buttons",
            acceptCallWhatsapp: "Notify that WhatsApp call is not accepted?",
            sendSignMessage: "Allow agent to choose to send Signature",
            sendGreetingMessageOneQueues:
              "Send Greeting when only one queue exists",
            sendQueuePosition: "Send Queue Position Message",
            sendFarewellWaitingTicket: "Send Farewell Message while Waiting",
            acceptAudioMessageContact:
              "Accept Audio Messages from All Contacts?",
            enableLGPD: "Enable LGPD Processing",
            requiredTag: "Required Tag to Close Ticket",
            closeTicketOnTransfer:
              "Close Ticket when Transferring to Another Queue",
            DirectTicketsToWallets: "Automatically Move Client to Wallet",
            showNotificationPending: "Show Notification for Pending Tickets",
            notifyOnTransfer: "Notify on Ticket Transfers",
          },
          customMessages: {
            sendQueuePositionMessage: "Queue Position Message",
            AcceptCallWhatsappMessage: "Message to Inform Call Not Accepted",
            greetingAcceptedMessage: "Greeting Message When Accepting Ticket",
            transferMessage:
              "Transfer Message - ${queue.name} = destination queue",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Welcome Message (LGPD)",
            linkLGPD: "Privacy Policy Link",
            obfuscateMessageDelete: "Obfuscate Deleted Message",
            alwaysConsent: "Always Request Consent",
            obfuscatePhoneUser: "Obfuscate User Phone Number",
            enabled: "Enabled",
            disabled: "Disabled",
          },
        },
      },
      messagesList: {
        messageFailed: "Failed to send message.",
        baileysAccountRestricted:
          "Connection {{name}}: account restricted by WhatsApp. Check the phone app for this connection.",
        baileysAccountRestrictedGeneric:
          "Account restricted by WhatsApp. Check the phone app for this connection.",
        scrollToBottom: "Go to latest message",
        scrollToQuoted: "Go to original message",
        searchScrollNotFound:
          "Could not find this message in the current conversation (history too old or message removed).",
        header: {
          assignedTo: "Assigned to:",
          dialogRatingTitle:
            "Would you like to leave a service rating for the client?",
          dialogClosingTitle: "Closing the service with the client!",
          dialogRatingCancel: "Resolve WITH Farewell Message",
          dialogRatingSuccess: "Resolve and Send Rating",
          dialogRatingWithoutFarewellMsg: "Resolve WITHOUT Farewell Message",
          ratingTitle: "Choose a rating menu",
          notMessage: "No message selected",
          amount: "Prospecting Value",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
            rating: "Send Rating",
            enableIntegration: "Enable Integration",
            disableIntegration: "Disable Integration",
            logTicket: "Ticket Logs",
            requiredTag: "You must assign a tag before closing the ticket.",
            greetingAcceptedMessage:
              "You must configure a greeting message when accepting the ticket.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Type a message or press / for quick replies",
        placeholderOpen: "Type a message or press / for quick replies",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
        privateMessage: "Private Message",
      },
      contactDrawer: {
        header: "Contact Details",
        searchScrollWrongTicket:
          "This message belongs to another ticket. Open that ticket to view it in context.",
        searchScrollNoUuid:
          "Could not open the other ticket (ticket identifier missing).",
        searchScrollStorageError:
          "Could not prepare navigation. Check that browser storage is allowed.",
        buttons: {
          edit: "Edit Contact",
          block: "Block",
          unblock: "Unblock",
          scheduledMessages: "Scheduled messages",
        },
        extraInfo: "Additional Information",
        scheduledMessages: {
          title: "Scheduled messages",
          pending: "Scheduled",
          sent: "Sent",
          sentLabel: "SENT",
          noPending: "No scheduled messages for this contact.",
          noSent: "No sent scheduled messages.",
        },
      },
      messageVariablesPicker: {
        label: "Available Variables",
        vars: {
          contactFirstName: "First Name",
          contactName: "Name",
          user: "Agent",
          greeting: "Greeting",
          protocolNumber: "Protocol Number",
          date: "Date",
          hour: "Hour",
          ticket_id: "Ticket Number",
          queue: "Sector",
          connection: "Connection",
        },
      },
      ticketOptionsMenu: {
        schedule: "Schedule",
        delete: "Delete",
        transfer: "Transfer",
        closeTicket: "Close Ticket",
        conversar: "Chat",
        registerAppointment: "Contact Notes",
        resolveWithNoFarewell: "Resolve without Farewell",
        acceptAudioMessage: "Accept audio messages from contact?",
        appointmentsModal: {
          title: "Ticket Notes",
          textarea: "Note",
          placeholder: "Enter the information you want to register here",
        },
        confirmationModal: {
          title: "Delete the contact's ticket",
          titleFrom: "from contact",
          message:
            "Attention! All messages related to this ticket will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Enable/Disable Signature",
          privateMessage: "Enable/Disable Private Message",
          meet: "Send video conference link",
        },
        type: {
          imageVideo: "Photos and Videos",
          cam: "Camera",
          contact: "Contact",
          meet: "Video Call",
          template: "Meta Template",
        },
        camera: {
          tabPhoto: "Photo",
          tabVideo: "Record video",
          preparing: "Preparing camera…",
          startRecord: "Start recording",
          stopSend: "Stop and send",
          accessError: "Could not use the camera. Check browser permissions.",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        edit: "Edit",
        forward: "Forward",
        toForward: "Forward",
        talkTo: "Talk To",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be undone.",
        },
        officialApiNoEditDelete: "With the WhatsApp Official API you cannot delete or edit messages. Changes apply only in the system.",
        officialApiNoReactions:
          "This channel (WhatsApp Official API) does not support emoji reactions.",
        channelNoReactions: "This channel does not support emoji reactions.",
        editModal: {
          title: "Edit message",
          edited: "Edited",
          placeholder: "Type a message",
          confirm: "Save edit",
        },
      },
      invoices: {
        table: {
          invoices: "Invoices",
          details: "Details",
          users: "Users",
          connections: "Connections",
          queue: "Queues",
          value: "Value",
          expirationDate: "Expiration Date",
          action: "Action",
        },
      },
      backendErrors: {
        ERR_OFFICIAL_NO_REACTIONS:
          "This channel (WhatsApp Official API) does not support emoji reactions.",
        ERR_CHANNEL_NO_REACTIONS: "This channel does not support emoji reactions.",
        ERR_NO_OTHER_WHATSAPP:
          "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check connections page.",
        ERR_SENDING_FACEBOOK_MSG:
          "Error sending message via Facebook/Instagram. Try again.",
        ERR_FACEBOOK_24H_WINDOW_CLOSED:
          "The 24-hour messaging window has closed. According to Meta's policies, you can only send messages within 24 hours after the customer's last message. Wait for the customer to contact you again to reply.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_INBOUND_ONLY_NO_OUTBOUND:
          "This connection is in “inbound only” mode: you cannot open a new ticket or send the first message. Wait for the contact to message you or use another connection.",
        ERR_CANNOT_DELETE_SUPER_ADMIN: "Cannot delete the super administrator user.",
        ERR_CANNOT_DELETE_MAIN_COMPANY: "Cannot delete the main system company.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating ticket on database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED:
          "Greeting message is required if there is more than one queue.",
        ERR_OUT_OF_HOURS: "Outside Business Hours!",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Method:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (registered token) and Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Message"',
        fieldUserId: '"userId": User ID or ""',
        fieldQueueId: '"queueId": Queue ID or ""',
        fieldSendSignature: '"sendSignature": Sign message - true/false',
        fieldCloseTicket: '"closeTicket": Close the ticket - true/false',
        singMessage: "Sign message - true/false",
        closeTicket: "Close the ticket - true/false",
        testSend: "The Test Send",
      },
      recurrenceSection: {
        title: "Recurrence",
        description:
          "You can choose to send the message recurrently and select the interval. If it is a one-time message, do not change anything in this section.",
        labelInterval: "Interval",
        intervalFilterValue: "Interval filter value",
        sendAsManyTimes: " Send as many times",
        shipNormallyOnNonbusinessDays: "Ship normally on non-business days",
        sendOneBusinessDayBefore: "Send one business day before",
        sendOneBusinessDayLater: "Send one business day later",
        options: {
          days: "Days",
          weeks: "Weeks",
          months: "Months",
          minutes: "Minutes",
        },
        servicePanel: {
          allowRealTime: "Service Panel",
        },
      },
      servicePanel: {
        allowRealTime: "Service Panel  ",
      },
      financial: {
        invoices: "Invoices",
        details: "Details",
        users: "Users",
        connections: "Connections",
        queues: "Queues",
        value: "Value",
        expirationDate: "Due Date",
        status: "Status",
        action: "Action",
      },
      statusFilter: {
        statusFilter: "Filter by Status",
      },
      momentsUser: {
        services: "Services:",
        pending: "Pending",
        noqueue: "NO QUEUE",
        viewTicket: "View Ticket",
      },
      dashboardTags: {
        title: "Tags Dashboard",
        unreadOnly: "Unread only",
        showAll: "Show all",
        onlyOpenPending: "Only Open/Pending Tickets",
        refresh: "Refresh",
        showingOf: "of",
        viewContent: "View content",
        ticketContent: "Ticket content",
        lastMessage: "Last message",
        close: "Close",
        openTicket: "Open ticket",
        queue: "Queue",
        user: "User",
        editContact: "Edit contact",
      },
      campaignsPhrase: {
        searchCampaign: "Search campaign…",
        noSearchResults: "No campaigns match your search.",
        campaignsFlow: "Campaigns Flow",
        campaigns: "Campaign",
        name: "Name",
        status: "Status",
        newCampaignWithFlowByPhrase: "New campaign with flow by phrase",
        editCampaignWithFlowByPhrase: "Edit campaign with flow by phrase",
        phraseTriggerName: "Phrase trigger name",
        chooseAStream: "Choose a stream",
        whichPhraseTriggersTheFlow: " Which phrase triggers the flow?",
        selectAConnection: " Select a Connection",
        chooseAStream: "Choose a stream",
        status: " Status",
        cancel: "CANCEL",
        createCampaign: "CREATE CAMPAIGN ",
        saveCampaign: "Sale Campaign",
      },
      chatList: {
        noMessages: "No messages",
        admin: "Admin",
        member: "Member",
        searchChat: "Search chat...",
        createNewChat: "Create new chat",
        searchUser: "Search user...",
        noUserFound: "No user found",
        noUserAvailable: "No user available",
        cancel: "Cancel",
        details: "Details",
        deleteChat: "Delete Chat",
        deleteChatConfirm: "This action cannot be undone, confirm?",
        detailsTitle: "Details",
        edit: "Edit",
        delete: "Delete",
        now: "now",
        minutesAgo: "{{count}}m ago",
        hoursAgo: "{{count}}h ago",
      },
      chatMessages: {
        deleted: "This message was deleted",
        deletedAdmin: "Deleted message - visible only to administrators",
        reply: "Reply",
        edit: "Edit",
        delete: "Delete",
        forward: "Forward",
        editMessage: "Edit Message",
        save: "Save",
        cancel: "Cancel",
        deleteMessage: "Delete Message",
        deleteMessageConfirm: "Are you sure you want to delete this message?",
        forwardMessage: "Forward Message",
        selectChat: "Select chat",
        doubleClickToReply: "Double click to reply",
        edited: "(edited)",
        forwarded: "(forwarded)",
        typeMessage: "Type a message...",
        send: "Send",
        noMessages: "No messages",
        loading: "Loading...",
        replyingTo: "Replying to",
        clickToGoToOriginal: "Click to go to original message",
      },
      chatPopover: {
        reply: "Reply",
        edit: "Edit",
        delete: "Delete",
        forward: "Forward",
        cancel: "Cancel",
        confirmDelete: "Confirm Delete",
        confirm: "Confirm",
        deleteMessage: "Are you sure you want to delete this message?",
        editMessage: "Edit Message",
        save: "Save",
        forwardMessage: "Forward Message",
        selectChat: "Select chat",
        forward: "Forward",
        noChats: "No chat available",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Groups",
        new: "New",
        messages: "Messages",
        search: "Search...",
        noChats: "No chat found",
        noGroups: "No group found",
        noMessages: "No messages",
        loading: "Loading...",
        error: "Error loading data",
        addGroupPhoto: "Add Group Photo",
        changeGroupPhoto: "Change Group Photo",
        groupName: "Group Name",
        groupDescription: "Group Description",
        save: "Save",
        cancel: "Cancel",
        createGroup: "Create Group",
        editGroup: "Edit Group",
        deleteGroup: "Delete Group",
        deleteGroupConfirm: "Are you sure you want to delete this group?",
        edit: "Edit",
        delete: "Delete",
        details: "Details",
        groupDetails: "Group Details",
        title: "Title",
        description: "Description",
        modal: {
          title: "Create Group",
          editTitle: "Edit Group",
          save: "Save",
          cancel: "Cancel",
          name: "Group Name",
          description: "Group Description",
          create: "Create",
          edit: "Edit",
        },
      },
      whitelabel: {
        primaryColorLight: "Primary Color (Light Theme)",
        primaryColorDark: "Primary Color (Dark Theme)",
        appName: "Application Name",
        logoLight: "Logo (Light Theme)",
        logoDark: "Logo (Dark Theme)",
        favicon: "Favicon",
        backgroundLight: "Background Image (Light Theme)",
        backgroundDark: "Background Image (Dark Theme)",
        preview: "Preview",
        delete: "Delete",
        upload: "Upload",
        availableLanguages: "Available Languages",
        atLeastOneLanguage: "At least one language must be enabled",

        sections: {
          general: "General Settings",
          generalDescription: "Configure the application name and basic information",
          colors: "Colors and Themes",
          colorsDescription: "Customize primary colors for light and dark themes",
          logos: "Logos and Images",
          logosDescription: "Upload application logos and background images",
          languages: "Available Languages",
          languagesDescription: "Select which languages will be available in the system"
        }
      }
    },
    whatsappModalRel: {
      form: {
        isOficial: "Support Report",
        ticketId: "Ticket ID",
        client: "Customer",
        number: "Number",
        agent: "Agent",
        date: "Date",
        lastMessage: "Last Message",
        fullReport: "The full report is attached above",
        resolveAndTriggerIntegration: "Resolve and Trigger Integration",
        elementNotFoundForExport: "Element not found for export.",
        reportFilename: "support_report",
      },
    },
  },
};

export { messages };
